import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment.dev';
import { FileService } from '../../../services/file.service';
import { LocalCampaignMedia } from '../../../helpers/enum';
import { PuntoapuntoLocalCampaignOrderService } from 'src/app/services/puntoapunto-local-campaign-order.service';
import { PuntoapuntoLocalCampaignService } from 'src/app/services/puntoapunto-local-campaign.service';
import { RenaultPuntoapuntoLocalCampaignOrderDTO } from 'src/app/models/renault-puntoapunto-local-campaign-order';
import { RenaultPuntoapuntoLocalCampaignDTO } from 'src/app/models/renault-puntoapunto-local-campaign';
import * as html2pdf from 'html2pdf.js';
import Swal from 'sweetalert2';

@Component({
  selector: 'puntoapunto-local-campaign-html-modal',
  templateUrl: './puntoapunto-local-campaign-html-modal.component.html',
  styleUrls: ['./puntoapunto-local-campaign-html-modal.component.scss']
})
export class PuntoapuntoLocalCampaignHtmlModalComponent implements OnInit {

  @Input() idOrder: string;
  modelOrder: RenaultPuntoapuntoLocalCampaignOrderDTO;
  modelCampign: RenaultPuntoapuntoLocalCampaignDTO;
  htmlOutput: SafeHtml;
  htmlOutputString: string;
  urlBase = environment.urlAPI;
  LocalCampaignMedia = LocalCampaignMedia;

  constructor(public activeModal: NgbActiveModal,
    private orderService: PuntoapuntoLocalCampaignOrderService,
    private campaignService: PuntoapuntoLocalCampaignService,
    private fileService: FileService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getCampaignOrder();
  }

  getCampaignOrder() {
    this.orderService.get(this.idOrder).subscribe(resp => {
      this.modelOrder = resp;
      this.getCampaign();
    });
  }

  getCampaign() {
    this.campaignService.get(this.modelOrder.IdCampaign).subscribe(resp => {
      this.modelCampign = resp;
      this.previewFile();
    });
  }

  previewFile() {
    if (this.modelCampign.HtmlOutputFile != null) {
      this.fileService.getFileDataTextByUrl(this.modelCampign.HtmlOutputFile.FileUri).subscribe(resp => {
        let formData = JSON.parse(this.modelOrder.Data);
        formData.push({ Key: 'UrlBase', Value: this.urlBase });
        formData.forEach(function (dataForm) {
          let re = new RegExp('&&' + dataForm.Key + '&&', 'gi');
          resp = resp.replace(re, dataForm.Value);
        });
        this.htmlOutput = this.sanitizer.bypassSecurityTrustHtml(resp);
        this.htmlOutputString = resp;
      });
    }
  }

  generarPDF() {

    //se le puede pasar this.activeModal (donde pone null) para cerrar la modal después de la descarga.
    this.orderService.generarPDF(this.htmlOutputString, this.modelCampign.Title, null)

  }


}
